import { render, staticRenderFns } from "./PRINT.vue?vue&type=template&id=724e733c&scoped=true&"
import script from "./PRINT.vue?vue&type=script&lang=js&"
export * from "./PRINT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724e733c",
  null
  
)

export default component.exports